// Tiny global event bus so any surface (legacy /ask deep-links, palette shortcuts)
// can open the Kasara copilot without prop drilling. A pending flag covers the
// fresh-page-load race where the caller fires before the widget has mounted.
export const KASARA_OPEN_EVENT = "kasara:open";

let pending = false;

export const openKasara = () => {
  pending = true;
  window.dispatchEvent(new CustomEvent(KASARA_OPEN_EVENT));
};

export const consumePendingKasaraOpen = () => {
  const p = pending;
  pending = false;
  return p;
};
